<div fxFlexFill fxLayout="column" style="min-height: 100vh;">
  <header fxLayout="column">
    <app-menu-bar></app-menu-bar>
  </header>
  <main role="main" fxFlex fxLayout="column">
    <router-outlet></router-outlet>
  </main>
  <footer fxLayout="column">
    <app-footer></app-footer>
  </footer>
</div>
